export function splitCellID(cellID: string): [number, number] {
  let [dateIndex = '', spotIndex = ''] = cellID.split(':');
  return [Number(dateIndex), Number(spotIndex)];
}
